import { render } from "./AllReview.vue?vue&type=template&id=a36c79ae&scoped=true"
import script from "./AllReview.vue?vue&type=script&lang=js"
export * from "./AllReview.vue?vue&type=script&lang=js"

import "./AllReview.vue?vue&type=style&index=0&id=a36c79ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36c79ae"]])

export default __exports__